import generateModel from './model';
import { generateOptions, optionsChanged } from './options';

const SkillMap = {
    generateModel,
    generateOptions,
    optionsChanged
}

export default SkillMap;
